import "./TermsOfService.module.css";
import Header from "@/reusable_sections/Header";
import TheTransparencyReport from "./sections/TheTransparencyReport";
import Footer from "@/reusable_sections/Footer";
export default function TermsOfServicePage() {
  return <div>
      <Header />
      <TheTransparencyReport />
      <Footer />
    </div>;
}